export default {
  resultsTitle: {
    id: 'bo_seller.insights.financial_report.results_title',
    defaultMessage: 'Sales and cost details',
  },
  resultsCount: {
    id: 'bo_seller.insights.financial_report.results_count',
    defaultMessage: '{count} KPIs',
  },
}
